module.exports = __webpack_public_path__ + "img/frameCardTwoImg.00848fb4.png";